import React from "react";
import "./FareBadge.css";

export default function FareBadge({ children }) {
  return <span className="fe2-fare-badge">{children}</span>;
}
